"use client"

import { useState } from "react"
import { toast } from "sonner"
import { createAnchorUrl } from "./utils"
import styles from "./AnchorButton.module.css"

interface AnchorButtonProps {
  headingId: string
  className?: string
}

export function AnchorButton({ headingId, className }: AnchorButtonProps) {
  const [isHovered, setIsHovered] = useState(false)

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    
    const anchorUrl = createAnchorUrl(headingId)
    
    try {
      await navigator.clipboard.writeText(anchorUrl)
      toast.success("Link copied to clipboard!")
    } catch (error) {
      // Fallback for browsers that don't support clipboard API
      console.error("Failed to copy to clipboard:", error)
      toast.error("Failed to copy link")
    }
  }

  return (
    <button
      className={`${styles.anchorButton} ${className || ""}`}
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label="Copy link to this heading"
      title="Copy link to this heading"
      type="button"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.linkIcon}
      >
        <path
          d="M6.879 9.934a2.991 2.991 0 0 1 0-4.131l1.867-1.867a3 3 0 0 1 4.242 4.242l-1.045 1.046"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.121 6.066a2.991 2.991 0 0 1 0 4.131l-1.867 1.867a3 3 0 0 1-4.242-4.242l1.045-1.046"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}

